import { Box, Typography } from "@mui/material";

export default function Section({ title, description, children, titleEmpty }: any) {
  return (
    <Box>

      { title && 
        <Typography fontSize={13} fontWeight={600} mb={0.5}>
          {title}
        </Typography>
      }

      
      {description && (
        <Typography fontSize={11} color="#6b7280" mb={1} 
          mt={title ? 1 : -2} 
          // sx={{ mt: titleEmpty && 2.8 }}
          sx={{
            mt: titleEmpty
              && {
                  xs: 0,
                  md: 2.8,
                }
              
          }}
          >
          {description}
        </Typography>
      )}

      {children}
    </Box>
  );
}
